import React from "react"
import { SeverityIndicatorProps, SeverityRange } from "./types"

export function getSeverityColor(ranges: SeverityRange[], value: number) {
  const { color: lastColor } = ranges[ranges.length - 1]
  const colorZone = ranges
    .sort((a, b) => a.limit - b.limit) // Ensure it is increasing
    .reduceRight((accColor, range) => {
      if (value < range.limit) {
        return range.color
      }
      return accColor
    }, lastColor)
  return colorZone
}

const SeverityIndicator: React.FC<SeverityIndicatorProps> = ({
  value,
  ranges,
  size = 20,
  color: propColor,
}) => {
  const color = propColor || getSeverityColor(ranges, value)
  const circleSize = size / 2
  return (
    <svg width={size} height={size}>
      <circle cx={circleSize} cy={circleSize} r={circleSize} fill={color} />
    </svg>
  )
}

export default SeverityIndicator
